(() => {
  const loader = document.querySelector('script[data-legal-recipe-source]');
  const content = document.querySelector('.article-template-content');
  const heroImage = document.querySelector('.article-template-hero-container img');
  const title = document.querySelector('.article-template h1');
  if (!loader || !content || !heroImage || !title) return;

  const hasRecipeSchema = [...document.querySelectorAll('script[type="application/ld+json"]')].some((script) => {
    try {
      const data = JSON.parse(script.textContent);
      const nodes = data['@graph'] || [data];
      return nodes.some((node) => node['@type'] === 'Recipe' || node['@type']?.includes?.('Recipe'));
    } catch (_) {
      return false;
    }
  });
  if (hasRecipeSchema) return;

  const children = [...content.children];
  const headingText = (element) => element.textContent.trim().replace(/\s+/g, ' ');
  const ingredientsIndex = children.findIndex(
    (element) => element.tagName === 'H2' && /ingr[ée]dients/i.test(headingText(element))
  );
  const preparationIndex = children.findIndex(
    (element) => element.tagName === 'H2' && /(?:comment pr[ée]parer|pr[ée]paration)/i.test(headingText(element))
  );
  if (ingredientsIndex < 0 || preparationIndex <= ingredientsIndex) return;

  const ingredientSection = children.slice(ingredientsIndex + 1, preparationIndex);
  const ingredientList = ingredientSection.find((element) => element.tagName === 'UL');
  if (!ingredientList) return;
  const ingredients = [...ingredientList.querySelectorAll('li')].map(headingText).filter(Boolean);

  const nextHeadingIndex = children.findIndex(
    (element, index) => index > preparationIndex && element.tagName === 'H2'
  );
  const preparationSection = children.slice(
    preparationIndex + 1,
    nextHeadingIndex < 0 ? undefined : nextHeadingIndex
  );
  const steps = preparationSection
    .filter((element) => element.tagName === 'H3' && /^Étape\s*\d+/i.test(headingText(element)))
    .map((heading, index) => {
      const paragraphs = [];
      for (
        let element = heading.nextElementSibling;
        element && element.tagName !== 'H2' && element.tagName !== 'H3';
        element = element.nextElementSibling
      ) {
        const value = headingText(element);
        if (value) paragraphs.push(value);
      }
      return {
        '@type': 'HowToStep',
        position: index + 1,
        name: headingText(heading),
        text: paragraphs.join(' ')
      };
    })
    .filter((step) => step.text);
  if (ingredients.length < 2 || steps.length === 0) return;

  const canonicalUrl = document.querySelector('link[rel="canonical"]')?.href || location.href.split('?')[0];
  const firstParagraph = content.querySelector('p')?.textContent.trim().replace(/\s+/g, ' ');
  const recipe = {
    '@context': 'https://schema.org',
    '@type': 'Recipe',
    '@id': `${canonicalUrl}#recipe`,
    mainEntityOfPage: { '@id': `${canonicalUrl}#webpage` },
    name: headingText(title),
    image: [new URL(heroImage.currentSrc || heroImage.src, location.href).href],
    datePublished: loader.dataset.publishedAt,
    dateModified: loader.dataset.modifiedAt,
    author: { '@id': `${location.origin}#organization` },
    publisher: { '@id': `${location.origin}#organization` },
    recipeIngredient: ingredients,
    recipeInstructions: steps
  };
  if (firstParagraph) recipe.description = firstParagraph;
  const servingsText = ingredientSection
    .filter((element) => element.tagName === 'P')
    .map(headingText)
    .join(' ');
  const servings = servingsText.match(/\b(\d+)\s+personnes?\b/i);
  if (servings) recipe.recipeYield = Number(servings[1]);

  const coreScript = document.querySelector('script[data-legal-structured-data="core"]');
  if (coreScript) {
    try {
      const core = JSON.parse(coreScript.textContent);
      if (Array.isArray(core['@graph'])) {
        const pageNode = core['@graph'].find((node) => node['@id'] === `${canonicalUrl}#webpage`);
        if (pageNode) {
          pageNode.mainEntity = { '@id': recipe['@id'] };
          core['@graph'] = core['@graph'].filter((node) => node['@id'] !== `${canonicalUrl}#article`);
          coreScript.textContent = JSON.stringify(core);
        }
      }
    } catch (_) {
      // Keep the visible-content recipe even if another script changed the core graph.
    }
  }

  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.dataset.legalStructuredData = 'recipe-content';
  script.textContent = JSON.stringify(recipe);
  document.head.appendChild(script);
})();
